/**
 * Heuristic only: matches company names that read as a Finnish municipality, joint municipal
 * authority, wellbeing services county, or parish (the entities behind kuntarekry.fi/kirkkorekry.fi,
 * see BLOCKED_DOMAINS in lambda/utils/company/company-eligibility.ts). There is no stored
 * municipality/government flag anywhere in the data model, so this is a name-pattern check used
 * only to keep these out of the FilterModal's default (unsearched) company list; a user can still
 * find and select one by typing its name.
 */
const MUNICIPALITY_OR_GOVERNMENT_NAME_PATTERNS = [
  /\bkaupunki\b/i,
  /\bkunta\b/i,
  /\bkuntayhtym[aä]\b/i,
  /\bhyvinvointialue\b/i,
  /\bseurakunta\b/i,
  /\bstad\b/i,
  /\bkommun\b/i,
  /\bsamkommun\b/i,
];

export function isLikelyMunicipalityOrGovernmentName(name: string): boolean {
  if (!name) return false;
  return MUNICIPALITY_OR_GOVERNMENT_NAME_PATTERNS.some((pattern) => pattern.test(name));
}
